'use client';

import { useEffect } from 'react';

import { preloadPayPalV6Sdk } from '@/hooks/use-pay/paypal-v6-redirect';

/** 应用启动后后台预加载 PayPal v6 SDK，不渲染 UI、不阻塞其他逻辑 */
export default function PayPalSdkPreload() {
    useEffect(() => {
        preloadPayPalV6Sdk();
    }, []);

    return null;
}
